namespace advisorop.components.advisor {
    
    export class AdminPanelController{
        $router;       
        public chartMarketValueByInvestor: domains.IChartDataSource;
        public chartMarketValueByHousehold: domains.IChartDataSource;
        showChart: boolean = false;
        selInvestorId: number = 0;
        adminMode: boolean = false;

        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.adminMode = this.advisorService.isAdminModeEnabled();
            });

            this.chartMarketValueByInvestor = {
                chart: { caption: "", numberPrefix: "", subCaption: "", theme: "" },
                data: []
            };

            this.chartMarketValueByHousehold = {
                chart: { caption: "", numberPrefix: "", subCaption: "", theme: "" },
                data: []
            };    
        }

        showIndividualChart() {
            this.showChart = !this.showChart;
        };

        changeHousehold(id) {
            this.advisorService.getMarketValueByHousehold(id).then((response) => {
                //this.chartMarketValueByHousehold.data = [];
                this.chartMarketValueByHousehold = response.data;
            }).catch((response) => {
                toastr.error("Market data error: " + response.status + ":" + response.data);
            });
        };

        changeInvestor(id) {
            this.advisorService.getMarketValueByInvestor(id)
                .then(response => {
                    this.showChart = true;
                    this.chartMarketValueByInvestor = response.data;
                }, err => {
                    toastr.error("Market data error: " + err.status + ":" + err.data);
                });
        };

        $onInit(): void {
            this.adminMode = this.advisorService.isAdminModeEnabled();                  
        }

        $routerOnActivate(next, previous) {            
        }        

    }



    class AdminPanel implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;
        $canActivate;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "advisorService", "$rootScope", AdminPanelController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/admin-panel.html';    
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (!advisorService.isAdminModeEnabled()) {
                    toastr.info("Please activate Admin Mode to enable Setup functionalities");
                    return false;
                }
                return true;
            }];        
        }
    }
    angular.module(Constants.APP).component("adminPanel", new AdminPanel());
    
}